/** Révèle — l'image décorative de survol reste sans URL active sur tactile. */
(function () {
  'use strict';

  const survol = window.matchMedia('(hover: hover) and (pointer: fine)');

  function chargerImage(image) {
    if (!image?.dataset.src) return;

    image.sizes = image.dataset.sizes;
    image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    delete image.dataset.sizes;
    delete image.dataset.srcset;
    delete image.dataset.src;
  }

  function prechargerImages() {
    if (!survol.matches) return;

    const chargerImages = () => {
      if (!survol.matches) return;
      document.querySelectorAll('.rv-product-card__image--hover[data-src]').forEach(chargerImage);
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(chargerImages);
    } else {
      window.setTimeout(chargerImages, 1500);
    }
  }

  if (document.readyState === 'complete') {
    prechargerImages();
  } else {
    window.addEventListener('load', prechargerImages, { once: true });
  }

  // Délégation : les filtres et la pagination peuvent remplacer les cartes.
  document.addEventListener('pointerenter', (evenement) => {
    if (!survol.matches || evenement.pointerType === 'touch') return;
    const carte = evenement.target.closest?.('.rv-product-card');
    const image = carte?.querySelector('.rv-product-card__image--hover[data-src]');
    chargerImage(image);
  }, true);
})();
